// Vuex
import store from '@/store.js';
import consts from "@/consts.js";
import Request from './request';

async function my(noLoading) {// 检查本地accessToken的登录状态
    const response = await Request('get', "api/account-users/my", null, noLoading);
    if (response.data && response.data.status.isOK()) {
        store.commit("USERINFO", response.data);
    }
    return response;
}

async function fetch(data) {
    return Request('get', "api/account-users", data);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/account-users", data);
}

export default {
    my,
    fetch,
    fetchAll,
};